import i18n from "../../../constants/i18n";
import Et3ATag from "../../../core/et3-a-tag";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Text from "../../../core/et3-text";

const ClientUserName = withLiteObserverAndTheme<{
  userID: number;
  userName: string;
  isSilentBanned: number;
}>((props) => {
  const { theme, userID, userName, isSilentBanned } = props;
  const { colors, unitX } = theme;
  const userNameWidth = isSilentBanned === 1 ? 156 : 190;
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="space-between"
      alignItems="center"
      withShadow={false}
      width={290}
      height={80}
      style={{}}
      onClick={() => {}}
      color={""}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={190}
        height={80}
        style={{}}
        onClick={() => {}}
        color={""}
      >
        <Et3ATag
          href={`/users/advanced?id=${userID}`}
          target="_blank"
          style={{
            color: `${colors.all.lavenderIndigo}`,
            width: userNameWidth * unitX
          }}
        >
          <Et3Text
            fontFamily="MEDIUM"
            fontSize={25}
            text={userName}
            isSpan={false}
            color={colors.all.black}
            style={{}}
          />
        </Et3ATag>

        {isSilentBanned === 1 ? (
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            fDirection="row"
            justifyContent="center"
            alignItems="center"
            withShadow={false}
            width={28}
            height={24}
            color={colors.all.red}
            style={{
              marginLeft: 6 * unitX,
              borderRadius: 4
            }}
            onClick={() => {}}
          >
            <Et3Text
              fontFamily="BOLD"
              fontSize={12}
              text={i18n.get("SILENT_BAN_ABBREVIATION")}
              isSpan={false}
              color={colors.all.white}
              style={{}}
            />
          </ET3Div>
        ) : null}
      </ET3Div>

      <Et3ATag
        href={`/users/advanced?id=${userID}`}
        target="_blank"
        style={{
          color: `${colors.all.lavenderIndigo}`,
          width: 100 * unitX
        }}
      >
        <Et3Text
          fontFamily="MEDIUM"
          fontSize={25}
          text={`${userID}`}
          isSpan={false}
          color={colors.all.black}
          style={{}}
        />
      </Et3ATag>
    </ET3Div>
  );
});

export default ClientUserName;
